import { memo } from 'react';

import { FooterNav } from './FooterNav';

export * from './FooterNav';

export default memo(FooterNav);
